import { useState, type FormEvent } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { BrandLogo } from '../../shared/BrandLogo'
import { useAdminAuth } from '../AuthProvider'
import { safeAdminError } from '../safe-ui'

export function AdminLoginPage() {
  const { login, isAuthenticated } = useAdminAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [rememberMe, setRememberMe] = useState(false)
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  if (isAuthenticated) {
    return (
      <div className="ap-auth">
        <div className="ap-auth__card">
          <p>Already signed in.</p>
          <Link className="pp-btn pp-btn--primary" to="/admin">
            Open Admin
          </Link>
        </div>
      </div>
    )
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError('')
    try {
      await login(email.trim(), password, rememberMe)
      navigate('/admin', { replace: true })
    } catch (err) {
      setError(safeAdminError(err, 'Unable to sign in. Check your credentials and try again.'))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="ap-auth">
      <form className="ap-auth__card" onSubmit={(e) => void onSubmit(e)}>
        <BrandLogo className="ap-auth__logo" tone="light" variant="mark" />
        <p className="cp-eyebrow">Master Admin</p>
        <h1>Operations console</h1>
        <p className="cp-muted">Sign in to manage Perfect Predict.</p>
        <label className="cp-field">
          Email
          <input
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label className="cp-field">
          <span style={{ display: 'flex', justifyContent: 'space-between', gap: '0.75rem' }}>
            <span>Password</span>
            <Link to="/admin/forgot-password" style={{ fontSize: '0.85rem' }}>
              Forgot password?
            </Link>
          </span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        <label className="cp-field ap-auth__remember">
          <input
            type="checkbox"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          />
          <span>Keep me signed in on this device</span>
        </label>
        <p className="cp-muted" style={{ fontSize: '0.8rem', marginTop: '-0.35rem' }}>
          Leave unchecked for safer sessions (browser close requires sign-in again).
        </p>
        {error ? <p className="cp-error">{error}</p> : null}
        <button type="submit" className="pp-btn pp-btn--primary" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  )
}
